import gsap from 'gsap';

// Detect menu click for takeover
let menuItems = document.querySelectorAll('.gavazzi-header.desktop .menu-takeover');
let backdrop = document.querySelector('.gavazzi-header.desktop .backdrop .content');
let closeTakeoverBtn = document.querySelector('.gavazzi-header.desktop .close-menu-takeover');

let mobileTakeover = document.querySelector('.gavazzi-header.mobile');
let mobileMenu = document.getElementById('gavazzi-main-menu-mobile');
let menuItemsMobile = document.querySelectorAll('.gavazzi-header.mobile .menu>.menu-item.menu-item-has-children');
let mobileMenuOpenBtn = document.querySelector('.gavazzi-header.mobile .open-menu');
let mobileMenuCloseBtn = document.querySelector('.gavazzi-header.mobile .close-menu');

let openSearchBtns = document.querySelectorAll('button.open-search');
let closeSearchBtns = document.querySelectorAll('button.close-search');

if(menuItems) {
    menuItems.forEach(function(item) {

        item.onclick = function(e){
            showDesktopTakeover(item);
            e.preventDefault();
        };

    });
}

if(backdrop){

    closeTakeoverBtn.onclick = function(){
        hideTakeover();
        return false;
    };
}


if(menuItemsMobile) {
    gsap.set('.below-menu-deep', {opacity: 0, y: 20});

    menuItemsMobile.forEach(function(item) {
        let link = item.querySelector('a');
        link.onclick = function(){
            item.classList.toggle('active-ancestor');
            mobileMenu.classList.toggle('open');
            mobileTakeover.classList.toggle('open');


            // Make each menu item slide and add opacity in with gsap
            let items = item.querySelectorAll('.sub-menu > li > a');

            if(item.classList.contains('active-ancestor')) {
                let delay = 0;
                items.forEach(function (item) {
                    delay += 0.02;
                    let tl = gsap.timeline();
                    tl.fromTo(item, {opacity: 0, x: 100}, {
                        opacity: 1,
                        x: 0,
                        duration: 0.3,
                        delay: delay,
                        ease: 'power2.out'
                    });
                });
                gsap.to('.below-menu-deep', {
                    opacity: 1,
                    y: 0,
                    duration: 0.3,
                    delay: delay + 0.2,
                    ease: 'power2.out'
                });
            } else {
                items.forEach(function (item) {
                   gsap.set(item, {opacity: 0, x: 100});
                });

                gsap.set('.below-menu-deep', {opacity: 0, y: 20});
            }



            return false;
        };
    });
}


if(openSearchBtns) {
    openSearchBtns.forEach(function(btn) {
        btn.onclick = function(){
            hideTakeover();
            document.body.classList.add('searching');
            jQuery('input[ref="webienSearchInput"]').focus();
            return false;
        };
    });
}



if(closeSearchBtns){
    closeSearchBtns.forEach(function(btn) {
        btn.onclick = function(){
            closeSearch();
            return false;
        };
    });
}


console.log(mobileMenuOpenBtn);
if(mobileMenuOpenBtn){

    console.log('Mobile menu detected');

    mobileMenuOpenBtn.onclick = function(){
        showMobileTakeover();
    };
    mobileMenuCloseBtn.onclick = function(){
        hideTakeover();
    };
}



function showDesktopTakeover(item){
    document.documentElement.classList.remove('menu-takeover');

    let classes = [].slice.apply(item.classList); // DomClassList to array

    let contentClass = classes.filter((classes) => classes.startsWith("takeover-"));

    // Get id from classname
    let arr = contentClass[0].split("takeover-");
    let id = arr[1];

    // Activate correct template in takeover
    let allContents = document.querySelectorAll('[class^=takeover-item-]');
    allContents.forEach(function(div){
        div.classList.remove('active');
    });
    let activeContent = document.querySelector('.backdrop .takeover-item-' + id);
    if(activeContent){
        activeContent.classList.add('active');
    }

    // Always start on top
    let div = document.querySelector('.desktop .backdrop');
    div.scrollTo(0,0);

    closeSearch();

    document.documentElement.classList.add('menu-takeover');
    return false;
}

function hideTakeover(item){
    document.documentElement.classList.remove('menu-takeover');
}

function closeSearch(){
    document.body.classList.remove('searching');
}

function showMobileTakeover(){

    console.log('Helllo');

    // Always start on top
    let div = document.querySelector('.mobile .backdrop');
    div.scrollTo(0,0);
    document.documentElement.classList.add('menu-takeover');
}

